export function addOrientationListener(orientationHandler) {
    return window.addEventListener('resize', orientationHandler);
}

export function getOrientation(){
    return window.innerHeight > window.innerWidth ? "portrait" : "landscape"
}